/**
 * A HOC wrapping Material UIs TableRow Component. Used to unify the styles
 * across all of our tables. NOTE: TableRow and HeaderRow are both <TableRow>
 * components, but HeaderRow components belong inside a TableHead, while
 * TableRow belongs inside TableBody.
 */
import { isEmpty } from 'lodash';
import React from 'react';
import { withStyles } from 'tss-react/mui';
import { TableRow } from '@mui/material';

const styles = (theme) => {
  if (isEmpty(theme)) return {};

  return {
    root: {
      backgroundColor: '#0a0908',
      height: '20px',
      boxShadow:
        '0px 1px 5px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12)',
      [theme.breakpoints.up('sm')]: {
        height: '35px',
      },
    },
  };
};

export default withStyles((props) => {
  const { classes } = props;
  return <TableRow className={classes.root} {...props} />;
}, styles);
